// import React, { useState, useEffect } from 'react';
import React from 'react';
import "./index.css"


export default function Header() {
    return (
        <nav className="navbar navbar-color" role="navigation" aria-label="main navigation">
            <div className="navbar-brand">
                <a className="navbar-item" href="/">
                    <p class="is-size-5 is-family-code">Nikhil's Portfolio</p>
                </a>
            </div>

            <div id="navbarBasicExample" className="navbar-menu">
                <div className="navbar-start is-family-monospace">
                </div>

                <div className="navbar-end">
                        <a href="#about" className="navbar-item is-family-monospace is-link">
                            About
                        </a>
                        <a href="#experience" className="navbar-item is-family-monospace">
                            Experience

                        </a>
                        <a href="#work" className="navbar-item is-family-monospace">
                            Work
                        </a>
                        <a href="#skills" className="navbar-item is-family-monospace">
                            Skills
                        </a>
                        <a href="#education" className="navbar-item is-family-monospace">
                            Education
                        </a>
                        <a href="#contact" className="navbar-item is-family-monospace">
                            Contact
                        </a>
                </div>
            </div>
        </nav>
    )
}
